var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEVentilationDuctsOutsideAir = function SvgEVentilationDuctsOutsideAir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 40,
    height: 12,
    transform: "translate(78 14) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 2,
    height: 39.99,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 1,
    height: 39.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    width: 1,
    height: 39.99,
    fill: "#787878"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "27 16.02 32 24 37 16.02 34 16.02 34 10 30 10 30 16.02 27 16.02",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.85,5.05c0,.61-.11,1.14-.32,1.6-.21.46-.51.81-.9,1.06-.39.25-.84.37-1.35.37s-.95-.12-1.35-.37c-.39-.25-.7-.6-.91-1.05-.21-.46-.32-.98-.33-1.58v-.35c0-.61.11-1.14.32-1.61.21-.46.52-.82.91-1.07s.84-.37,1.35-.37.96.12,1.35.37.69.59.91,1.05c.21.46.32.99.32,1.6v.35ZM27.77,4.73c0-.69-.13-1.22-.39-1.59-.26-.37-.63-.55-1.11-.55s-.83.18-1.1.55c-.26.37-.4.88-.4,1.55v.36c0,.68.13,1.21.4,1.59s.64.56,1.11.56.85-.18,1.1-.55.39-.9.39-1.6v-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93,8V1.78h1.84c.55,0,1.04.12,1.46.37.43.25.76.59.99,1.04.23.45.35.97.35,1.55v.31c0,.59-.12,1.11-.35,1.56-.24.45-.57.79-1,1.03-.43.24-.93.36-1.49.36h-1.79ZM31.01,2.65v4.49h.71c.57,0,1-.18,1.31-.53.3-.35.46-.86.46-1.53v-.35c0-.67-.15-1.19-.44-1.55-.29-.36-.72-.53-1.28-.53h-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.04,6.55h-2.41l-.5,1.45h-1.12l2.35-6.22h.97l2.35,6.22h-1.13l-.51-1.45ZM36.93,5.68h1.8l-.9-2.58-.9,2.58Z"
  })))));
};
export default SvgEVentilationDuctsOutsideAir;